import PropTypes from "prop-types";

import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";
import { PromotionCampaignFormDialog } from "../promotion-campaign-form-dialog";

import { Button } from "@mui/material";

export const AddPromotionCampaignFormDialog = ({
  isOpen,
  onClose,
  onSubmitted,
}) => {
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async ({ name, description, status }) => {
    try {
      await apiClient.post("promotion-campaigns", {
        name,
        description,
        status,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal menambahkan kampanye promosi"));

      throw error;
    }
  };

  return (
    <PromotionCampaignFormDialog
      isOpen={isOpen}
      onClose={onClose}
      dialogTitle="Tambah Kampanye Promosi"
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Tambah
        </Button>
      )}
    />
  );
};

AddPromotionCampaignFormDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
};
